import { Box } from '@mui/material';
import { UploadIcon } from '@radix-ui/react-icons';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { LIST_COMMENTAIRE, TEST_SOUSCRIPTION } from '../../Utils/constant';
import { store } from '../../services/service';
import { useStoreForfait } from '../../store/Paramettre/forfaitStore';
import { useStoreApp } from '../../store/storeApp';
import { SubmitButton } from '../Widget/SubmitButton';
import { ValidateMessage } from '../Widget/ValidateMessage';

export const SouscriptionTest = ({ numeroTicket }) => {
    const forfait = useStoreForfait()
    const [isSubmit, setIsSubmit] = useState(false)
    const [fichier, setFichier] = useState([])
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const commentaire = useStoreApp()
    useEffect(() => {
        commentaire.getData(LIST_COMMENTAIRE, { page: 0, param: "", size: 10 }, '')
        forfait.forfait({ page: 0, param: "", size: 1000 })
    }, [])

    const handleChangeFichier = (e) => {
        const selectedFiles = e.target.files;
        if (fichier.length <= 0) {
            const newFiles = Array.from(selectedFiles)
            setFichier(prevFiles => [...prevFiles, ...newFiles])
        } else {
            const newFiles = Array.from(selectedFiles)
            setFichier(newFiles)
        }
    }

    const submit = (data) => {
        setIsSubmit(true)
        const requestData = { ...data, status: 'REALISER', numeroTicket: numeroTicket, fichier: fichier[0] }
        store(TEST_SOUSCRIPTION, 'multipart/form-data', requestData).then((res) => {
            if (res.status === 200) {
                setIsSubmit(null)
                toast.success('Test effectué')
            }
        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err?.response?.data?.donnee)
        })
    }
    return (
        <>
            {
                isSubmit !== null ?
                    <form onSubmit={handleSubmit(submit)} className="w-full flex flex-col  items-start  mt-6">
                        <div className='w-full lg:w-96 items-start my-4 space-y-4'>
                            <div className='my-2'>
                                <label className="form-control w-full">
                                    <div className="label">
                                        <span className="label-text text-sm font-semibold">Resultat du test</span>
                                    </div>
                                    <select
                                        {...register("resultat", { required: true })}
                                        className="select select-bordered w-full">
                                        <option value={''} disabled selected>Selectionnez un status</option>
                                        <option value={'OK'}>OK</option>
                                        <option value={'NON_OK'}>Non OK</option>
                                    </select>
                                </label>
                            </div>
                            <label className="form-control  w-full">
                                <div className="label -mb-1">
                                    <span className="label-text font-medium text-gray-400">
                                        Débit constaté (M/s) <span className="text-red-500">*</span>
                                    </span>
                                </div>

                                <input
                                    {...register("debit", { required: true })}
                                    type="number"
                                    placeholder="300 M/s"
                                    min={0}
                                    className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none input input-bordered text-gray-500 w-full h-10 text-sm font-semibold"
                                />
                            </label>
                            <div>
                                <label className="form-contro  w-full">
                                    <div className="label flex flex-col justify-start items-start gap-1.5">
                                        <span className="label-text  font-medium text-gray-400">
                                            Capture du debit
                                        </span>
                                        <div className="w-full">
                                            {
                                                fichier.length !== 0 ? (
                                                    fichier.map((debitFile, index) => (
                                                        <div key={index} className="text-black py-14 border-dashed border-2 bg-gray-200 border-gray-300 px-3 my-2 w-full rounded-mdshadow-sm "
                                                            style={{
                                                                background: "url('" + URL.createObjectURL(debitFile) + "') no-repeat center/cover"
                                                            }}
                                                            onClick={() => document.getElementById('fichier').click()}
                                                        >
                                                        </div>
                                                    ))

                                                ) : (
                                                    <div className="text-black py-8 border-dashed border-2 bg-gray-200 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm "
                                                        onClick={() => document.getElementById('fichier').click()}
                                                    >
                                                        <div className='flex justify-center mb-3'>
                                                            <UploadIcon />
                                                        </div>

                                                        <div>
                                                            <p className='text-center text-sm mx-1'>Capture du debit</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>

                                </label>
                            </div>

                            <label className="form-control w-full">
                                <div className="label -mb-1">
                                    <span className="label-text font-medium text-gray-400">
                                        Type commentaire
                                    </span>
                                </div>
                                <select {...register("typeCommentaire", { required: true })} className="select select-bordered w-full h-10 lg:max-w-xs ">
                                    <option disabled selected>Selectionnez un type</option>
                                    {
                                        commentaire?.data?.data?.map((item) => (
                                            <option value={item.id}>{item.designation}</option>
                                        ))
                                    }
                                </select>

                            </label>

                            <div className='my-2'>
                                <label htmlFor="" className='text-sm font-medium'>Commentaire</label>
                                <textarea
                                    {...register("commentaire")}
                                    placeholder="Votre commentaire" className="textarea textarea-bordered textarea-sm w-full" ></textarea>
                            </div>


                        </div>
                        <SubmitButton isSubmit={isSubmit} label={"Enregistrer"} />
                        <input type="file" accept="image/jpeg, image/png " hidden id='fichier' onChange={handleChangeFichier} />

                    </form>
                    : <ValidateMessage texte={'Test de connectivité éffectuée'} />
            }

            <div className="w-full mt-4">
                <hr />
                <div
                    className="flex mt-4"
                    sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                >

                    <Box sx={{ flex: "1 1 auto" }} />
                    <span
                        disabled={isSubmit !== null ? true : false}
                        className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
                        onClick={() => {
                            window.history.back()
                            localStorage.removeItem('numeroTicket')
                        }}
                    >
                        Terminer
                    </span>
                </div>
            </div>
        </>
    )
}
